const updateItems = [
  { date: '07.31', tag: '新片上线', text: '《暗夜追踪》高清完整版正式上线，悬疑动作片爱好者不容错过', dot: 'bg-primary-500' },
  { date: '07.30', tag: '片库更新', text: '经典港片专区新增20部周星驰系列电影，欢笑不断', dot: 'bg-accent-500' },
  { date: '07.29', tag: '专题推荐', text: '夏日观影指南：10部清凉感十足的北欧电影推荐', dot: 'bg-secondary-500' },
  { date: '07.28', tag: '系统优化', text: '菲菲影院全面升级播放器，加载速度提升40%，观影更流畅', dot: 'bg-primary-500' },
  { date: '07.27', tag: '新片上线', text: '高分喜剧《笑林奇遇》独家上线，口碑炸裂笑到停不下来', dot: 'bg-accent-500' },
  { date: '07.26', tag: '片库更新', text: '科幻巨制《星际边界》导演剪辑版加入片库，额外30分钟内容', dot: 'bg-secondary-500' },
  { date: '07.25', tag: '功能预告', text: '移动端APP即将支持离线缓存功能，随时随地看大片', dot: 'bg-primary-500' },
  { date: '07.24', tag: '观影活动', text: '「夏日电影马拉松」活动开启，连看5部电影解锁专属徽章', dot: 'bg-accent-500' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">最新快讯</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">菲菲影院最新电影上线、片库更新与平台动态</p>
        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-3 md:left-4 top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-6">
            {updateItems.map((item) => (
              <div key={item.text} className="relative">
                <span className={`absolute -left-[22px] md:-left-[26px] top-1.5 w-3 h-3 rounded-full ${item.dot} ring-4 ring-background-100`}></span>
                <div className="flex flex-wrap items-baseline gap-2 md:gap-3">
                  <span className="text-xs font-mono text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className="px-2 py-0.5 rounded-md bg-background-200 text-xs font-medium text-foreground-700 whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-sm text-foreground-700 mt-1.5 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}